const LOAD_DATA_TICKET           = 'LOAD_DATA_TICKET'
const LOAD_DATA_TICKET_SUCCESS   = 'LOAD_DATA_TICKET_SUCCESS'
const LOAD_DATA_TICKET_FAILED    = 'LOAD_DATA_TICKET_FAILED'
const UNMOUNT_DATA_TICKET        = 'UNMOUNT_DATA_TICKET'
const initialState = {
  loading: true,
  meta: null,
  data: null,
  message: null,
}
const ticketReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_TICKET:
      return {
        ...state,
        loading: true,
        meta: null,
        data: null,
      }
    case LOAD_DATA_TICKET_SUCCESS:
      return { 
        ...state, 
        loading: false,
        meta: action.payload.meta,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DATA_TICKET_FAILED:
      return { 
        ...state, 
        loading: true,
        meta: null,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DATA_TICKET:
      return { 
        ...state, 
        loading: true,
        meta: null,
        data: null,
      }
    default:
      return state
  }
}
export default ticketReducer;